<template>
	<MStateBox :loading="investment_activity.loading" :empty="isEmpty">
		<BreifCard
			:listData="activityList"
			:isShowType="isNotEn"
			:styleConfig="styleConfig"
			@goToDetail="handleClick"
		></BreifCard>
	</MStateBox>
</template>

<script setup>
import BreifCard from '@rebuild/materials/shared/common/flowX/breif-card.vue';
import { computed, onMounted } from 'vue';
import MStateBox from '@rebuild/components/MStateBox.vue';
import i18n from '@/locales';
import { useCurrentContext, useCurrentReactive } from '@rebuild/materials/shared/investment_activity/context';

defineProps({
	styleConfig: {
		type: [String, Number],
		default: 1
	}
});

const context = useCurrentContext();

const isNotEn = computed(() => {
	return i18n.locale != 'en';
});

const { viewActivity, skipInHK09606, investment_activity, refreshComponent } = useCurrentReactive();
const handleClick = item => {
	return viewActivity(item);
};

const isEmpty = computed(() => {
	const { data, empty } = investment_activity;
	return empty || !data?.rows?.length;
});
const activityList = computed(() => {
	const { data } = investment_activity;
	const { rows } = data || {};
	const newRows = (rows || []).map(item => {
		item.disabled = skipInHK09606(item);
		return item;
	});
	return formatRows(context.formattedOverview(newRows));
});

const formatRows = rows => {
	const types = { 3: '调研纪要', 8: '路演活动', 9: '调研活动' };
	const newRows = rows.map(item => {
		item.dataType = types[item.businessTypes];
		item.time = item.date;
		return item;
	});
	return newRows;
};

onMounted(() => {
	refreshComponent();
});
</script>
